/* ════════════════════════════════════════════════════════════════════
 *  EMPREGARE — SITE INSTITUCIONAL B2B  ·  Script global
 *  Compilado pelo webpack → js/build/empresa-global.min.js
 *
 *  Comportamentos do layout compartilhado:
 *    · Header sticky com sombra ao rolar
 *    · Mega menu (hover no desktop + teclado/acessível)
 *    · Drawer mobile/tablet com overlay e focus-trap
 *    · Acordeões do drawer
 *    · Seletor de idioma
 *  Utilitários reaproveitados pelas páginas:
 *    · Tabs  ·  FAQ  ·  Reveal on scroll (.fade-in)  ·  Count-up
 * ════════════════════════════════════════════════════════════════════ */

(function () {
    'use strict';

    // sinaliza que o bundle carregou (o watchdog inline no <head> reverte
    // html.js se isto nunca rodar, evitando conteúdo preso invisível)
    try { window.__ev2ready = true; } catch (e) {}

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var NAV_BP = 1024; // precisa casar com $bp-header do SCSS (ponto em que a nav desktop aparece / drawer some — limite de tablet)

    /* Util: roda quando o DOM estiver pronto */
    function ready(fn) {
        if (document.readyState !== 'loading') { fn(); }
        else { document.addEventListener('DOMContentLoaded', fn); }
    }

    /* ── 1. HEADER: compacta ao rolar (esconde a topbar) ──────────────
     *  Usa HISTERESE (dois limites) em vez de um só. Como colapsar a topbar
     *  reduz a altura do header (~50px) e isso pode reempurrar o scroll, um
     *  limite único causava oscilação ("menu pulando"). A zona morta entre
     *  ENTER (90) e EXIT (10) é maior que essa variação, quebrando o loop. */
    function initHeaderScroll() {
        // marca o WRAPPER (topnav) e não o header: assim a topbar — que é
        // irmã ANTERIOR do header — também reage ao scroll (colapsa) via CSS.
        var topnav = document.querySelector('.ev2-topnav') || document.getElementById('ev2-header');
        if (!topnav) return;

        var ENTER = 90, EXIT = 10;   // zona morta > altura que a topbar colapsa
        var scrolled = false, ticking = false;
        function update() {
            var y = window.pageYOffset || document.documentElement.scrollTop || 0;
            if (!scrolled && y > ENTER) { scrolled = true; topnav.classList.add('is-scrolled'); }
            else if (scrolled && y < EXIT) { scrolled = false; topnav.classList.remove('is-scrolled'); }
            ticking = false;
        }
        update();
        window.addEventListener('scroll', function () {
            if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
    }

    /* ── 2. MEGA MENU (desktop) ───────────────────────────────────── */
    function initMegaMenu() {
        var items = Array.prototype.slice.call(document.querySelectorAll('[data-mega-item]'));
        if (!items.length) return;

        var openItem = null;
        var closeTimer = null;

        function panelOf(item) { return item.querySelector('[data-mega-panel]'); }
        function btnOf(item) { return item.querySelector('[data-mega-toggle]'); }

        function open(item) {
            if (openItem && openItem !== item) close(openItem);
            window.clearTimeout(closeTimer);
            var panel = panelOf(item), btn = btnOf(item);
            if (!panel || !btn) return;
            panel.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            openItem = item;
        }
        function close(item) {
            var panel = panelOf(item), btn = btnOf(item);
            if (panel) panel.classList.remove('is-open');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            if (openItem === item) openItem = null;
        }
        function closeAll() { items.forEach(close); }

        items.forEach(function (item) {
            var btn = btnOf(item);
            if (!btn) return;

            // hover (somente quando o menu desktop está visível)
            item.addEventListener('mouseenter', function () {
                if (window.innerWidth >= NAV_BP) open(item);
            });
            item.addEventListener('mouseleave', function () {
                if (window.innerWidth >= NAV_BP) {
                    closeTimer = window.setTimeout(function () { close(item); }, 120);
                }
            });

            // click/toque
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (openItem === item) { close(item); }
                else { open(item); }
            });

            // teclado: fecha ao sair do item por foco
            item.addEventListener('focusout', function (e) {
                if (!item.contains(e.relatedTarget)) close(item);
            });
        });

        // Escape fecha o que estiver aberto e devolve foco ao botão
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && openItem) {
                var btn = btnOf(openItem);
                close(openItem);
                if (btn) btn.focus();
            }
        });

        // clique fora fecha
        document.addEventListener('click', function (e) {
            if (openItem && !openItem.contains(e.target)) closeAll();
        });
    }

    /* ── 3. DRAWER mobile/tablet ──────────────────────────────────── */
    function initDrawer() {
        var drawer = document.getElementById('ev2-drawer');
        var overlay = document.querySelector('.ev2-overlay');
        var openers = document.querySelectorAll('[data-drawer-open]');
        var closers = document.querySelectorAll('[data-drawer-close]');
        if (!drawer || !overlay) return;

        var lastFocused = null;

        function focusables() {
            return Array.prototype.slice.call(drawer.querySelectorAll(
                'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
            )).filter(function (el) { return el.offsetParent !== null; });
        }

        function open() {
            lastFocused = document.activeElement;
            overlay.hidden = false;
            // força reflow p/ a transição do overlay
            void overlay.offsetWidth;
            drawer.classList.add('is-open');
            overlay.classList.add('is-open');
            document.body.classList.add('ev2-no-scroll');
            drawer.setAttribute('aria-hidden', 'false');
            openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
            var f = focusables();
            if (f.length) f[0].focus();
        }
        function close() {
            drawer.classList.remove('is-open');
            overlay.classList.remove('is-open');
            document.body.classList.remove('ev2-no-scroll');
            drawer.setAttribute('aria-hidden', 'true');
            openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
            window.setTimeout(function () { overlay.hidden = true; }, 400);
            if (lastFocused) lastFocused.focus();
        }
        function isOpen() { return drawer.classList.contains('is-open'); }

        openers.forEach(function (b) { b.addEventListener('click', open); });
        closers.forEach(function (b) { b.addEventListener('click', close); });

        document.addEventListener('keydown', function (e) {
            if (!isOpen()) return;
            if (e.key === 'Escape') { close(); return; }
            // focus-trap
            if (e.key === 'Tab') {
                var f = focusables();
                if (!f.length) return;
                var first = f[0], last = f[f.length - 1];
                if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
                else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
            }
        });

        // fecha o drawer se a tela crescer para desktop
        window.addEventListener('resize', function () {
            if (window.innerWidth >= NAV_BP && isOpen()) close();
        });
    }

    /* ── 4. ACORDEÕES (drawer) ────────────────────────────────────── */
    function initAccordions() {
        var toggles = document.querySelectorAll('[data-acc-toggle]');
        toggles.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var panel = btn.parentElement.querySelector('[data-acc-panel]');
                var expanded = btn.getAttribute('aria-expanded') === 'true';
                btn.setAttribute('aria-expanded', String(!expanded));
                if (panel) panel.classList.toggle('is-open', !expanded);
            });
        });
    }

    /* ── 5. SELETOR DE IDIOMA ─────────────────────────────────────── */
    function initLangSwitch() {
        var toggles = document.querySelectorAll('[data-lang-toggle]');
        toggles.forEach(function (btn) {
            var wrap = btn.closest('.ev2-lang');
            var menu = wrap ? wrap.querySelector('[data-lang-menu]') : null;
            if (!menu) return; // ex.: botão decorativo do footer
            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                var open = menu.classList.toggle('is-open');
                btn.setAttribute('aria-expanded', String(open));
            });
            document.addEventListener('click', function (e) {
                if (!wrap.contains(e.target)) {
                    menu.classList.remove('is-open');
                    btn.setAttribute('aria-expanded', 'false');
                }
            });
        });
    }

    /* ── 6. TABS genéricas ────────────────────────────────────────────
     *  <div data-tabs>
     *     <button data-tab-btn="id">…</button>
     *     <div data-tab-pane="id">…</div>
     *  Ativa a primeira aba por padrão. Autocontido por container. */
    function initTabs() {
        var groups = document.querySelectorAll('[data-tabs]');
        groups.forEach(function (group) {
            var btns = Array.prototype.slice.call(group.querySelectorAll('[data-tab-btn]'));
            var panes = Array.prototype.slice.call(group.querySelectorAll('[data-tab-pane]'));
            if (!btns.length) return;

            function activate(id) {
                btns.forEach(function (b) {
                    var on = b.getAttribute('data-tab-btn') === id;
                    b.classList.toggle('is-active', on);
                    b.setAttribute('aria-selected', String(on));
                });
                panes.forEach(function (p) {
                    p.classList.toggle('is-active', p.getAttribute('data-tab-pane') === id);
                });
            }

            btns.forEach(function (b) {
                b.addEventListener('click', function () { activate(b.getAttribute('data-tab-btn')); });
            });

            var initial = group.querySelector('[data-tab-btn].is-active') || btns[0];
            activate(initial.getAttribute('data-tab-btn'));
        });
    }

    /* ── 7. FAQ (accordion acessível e EXCLUSIVO por grupo) ───────── */
    function initFaq() {
        var groups = document.querySelectorAll('[data-faq]');
        if (!groups.length) return;

        groups.forEach(function (group) {
            var items = Array.prototype.slice.call(group.querySelectorAll('[data-faq-toggle]'));

            function setItem(btn, open) {
                btn.setAttribute('aria-expanded', String(open));
                var panel = btn.nextElementSibling;
                if (panel) panel.classList.toggle('is-open', open);
                var facc = btn.closest('.ev2-facc');
                if (facc) facc.classList.toggle('is-open', open);
            }

            items.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var willOpen = btn.getAttribute('aria-expanded') !== 'true';
                    // fecha TODOS do mesmo grupo e abre apenas o clicado
                    items.forEach(function (other) { setItem(other, false); });
                    if (willOpen) setItem(btn, true);
                });
            });
        });
    }

    /* ── 8. REVEAL on scroll (.fade-in → .is-visible) ─────────────── */
    function initReveal() {
        var els = document.querySelectorAll('.fade-in');
        if (!els.length) return;

        if (prefersReducedMotion || !('IntersectionObserver' in window)) {
            els.forEach(function (el) { el.classList.add('is-visible'); });
            return;
        }
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

        els.forEach(function (el) { io.observe(el); });
    }

    /* ── 9. COUNT-UP ([data-count]) ───────────────────────────────── */
    function initCountUp() {
        var els = document.querySelectorAll('[data-count]');
        if (!els.length) return;

        function format(n) { return n.toLocaleString('pt-BR'); }

        function run(el) {
            var target = parseFloat(el.getAttribute('data-count')) || 0;
            var suffix = el.getAttribute('data-suffix') || '';
            if (prefersReducedMotion) { el.textContent = format(target) + suffix; return; }

            var dur = 1400, start = null;
            function step(ts) {
                if (!start) start = ts;
                var p = Math.min((ts - start) / dur, 1);
                var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
                el.textContent = format(Math.round(target * eased)) + suffix;
                if (p < 1) window.requestAnimationFrame(step);
            }
            window.requestAnimationFrame(step);
        }

        if (!('IntersectionObserver' in window)) {
            els.forEach(run);
            return;
        }
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); }
            });
        }, { threshold: 0.4 });
        els.forEach(function (el) { io.observe(el); });
    }

    /* ── 9b. CARROSSEL DE DEPOIMENTOS ([data-quotes]) ─────────────── */
    function initQuotes() {
        var root = document.querySelector('[data-quotes]');
        if (!root) return;
        var track = root.querySelector('[data-quotes-track]');
        var dotsWrap = root.querySelector('[data-quotes-dots]');
        var prev = root.querySelector('[data-quotes-prev]');
        var next = root.querySelector('[data-quotes-next]');
        if (!track) return;

        var cards = Array.prototype.slice.call(track.children);
        if (!cards.length) return;

        // passo = distância entre o início de dois cards (largura + gap)
        function step() {
            return cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth;
        }
        function current() {
            var s = step();
            return s ? Math.round(track.scrollLeft / s) : 0;
        }
        function goTo(idx) {
            idx = Math.max(0, Math.min(idx, cards.length - 1));
            track.scrollTo({ left: idx * step(), behavior: 'smooth' });
        }

        // dots (um por depoimento)
        var dots = [];
        if (dotsWrap) {
            cards.forEach(function (_, idx) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'ev2-quotes__dot';
                b.setAttribute('aria-label', 'Ir ao depoimento ' + (idx + 1));
                b.addEventListener('click', function () { goTo(idx); });
                dotsWrap.appendChild(b);
                dots.push(b);
            });
        }

        function update() {
            var c = current();
            dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === c); });
            var maxScroll = track.scrollWidth - track.clientWidth - 2;
            if (prev) prev.disabled = track.scrollLeft <= 2;
            if (next) next.disabled = track.scrollLeft >= maxScroll;
        }

        if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
        if (next) next.addEventListener('click', function () { goTo(current() + 1); });

        var ticking = false;
        track.addEventListener('scroll', function () {
            if (!ticking) { window.requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
    }

    /* ── 10. Âncoras "#" inertes (evita salto ao topo) ────────────── */
    function initInertAnchors() {
        document.querySelectorAll('a[href="#"]').forEach(function (a) {
            a.addEventListener('click', function (e) { e.preventDefault(); });
        });
    }

    /* ── 11. Rotador de palavras do hero ([data-rotator]) ─────────── */
    function initWordRotator() {
        var roots = document.querySelectorAll('[data-rotator]');
        if (!roots.length) return;

        roots.forEach(function (root) {
            var words = (root.getAttribute('data-rotator-words') || '')
                .split(',').map(function (w) { return w.trim(); }).filter(Boolean);
            var wordEl = root.querySelector('.ev2-rotator__word');
            if (!wordEl || words.length < 2) return;

            var idx = words.indexOf((wordEl.textContent || '').trim());
            if (idx < 0) idx = 0;

            // Reserva a largura da maior palavra p/ a frase não "pular".
            function reserveWidth() {
                var max = 0, current = wordEl.textContent, t = wordEl.style.transition;
                wordEl.style.transition = 'none';
                words.forEach(function (w) {
                    wordEl.textContent = w;
                    if (wordEl.offsetWidth > max) max = wordEl.offsetWidth;
                });
                wordEl.textContent = current;
                wordEl.style.transition = t;
                if (max) root.style.minWidth = max + 'px';
            }
            if (document.fonts && document.fonts.ready) { document.fonts.ready.then(reserveWidth); }
            else { reserveWidth(); }

            // a largura reservada é medida em px no viewport atual, mas o título usa
            // clamp(): sem re-medir, girar a palavra depois de um resize corta o texto
            var rzTimer;
            window.addEventListener('resize', function () {
                clearTimeout(rzTimer);
                rzTimer = setTimeout(function () { root.style.minWidth = ''; reserveWidth(); }, 150);
            });

            if (prefersReducedMotion) return; // não gira: mantém a 1ª palavra

            var DUR = 460, HOLD = 2200;
            function tick() {
                idx = (idx + 1) % words.length;
                var next = words[idx];
                wordEl.classList.add('is-out');               // sobe + some
                window.setTimeout(function () {
                    wordEl.textContent = next;
                    wordEl.classList.add('is-pre');           // reposiciona embaixo (sem transição)
                    wordEl.classList.remove('is-out');
                    void wordEl.offsetWidth;                  // força reflow
                    wordEl.classList.remove('is-pre');        // anima a entrada
                }, DUR);
            }
            window.setInterval(tick, HOLD + DUR);
        });
    }

    /* ── 12. FILTRO de conteúdo por categoria ([data-filter]) ─────── */
    function initContentFilter() {
        var roots = document.querySelectorAll('[data-filter]');
        if (!roots.length) return;

        roots.forEach(function (root) {
            var btns = Array.prototype.slice.call(root.querySelectorAll('[data-filter-btn]'));
            var target = root.getAttribute('data-filter-target');
            var grid = target ? document.querySelector(target) : null;
            if (!grid || !btns.length) return;

            var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cat]'));

            function apply(cat) {
                cards.forEach(function (card) {
                    card.hidden = !(!cat || card.getAttribute('data-cat') === cat);
                });
            }

            btns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    btns.forEach(function (b) {
                        var on = b === btn;
                        b.classList.toggle('is-active', on);
                        b.setAttribute('aria-pressed', String(on));
                    });
                    apply(btn.getAttribute('data-filter-btn'));
                });
            });
        });
    }

    /* ── ILUSTRAÇÕES ANIMADAS (.mk-anim): pausa fora da tela ────────── */
    // o loop roda no compositor (quase sem CPU), mas segue gastando GPU/bateria; de
    // brinde, a montagem de um SVG abaixo da dobra só acontece quando ele aparece
    function initMkAnim() {
        var svgs = document.querySelectorAll('.mk-anim');
        if (!svgs.length || prefersReducedMotion || !('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                entry.target.classList.toggle('is-paused', !entry.isIntersecting);
            });
        });
        svgs.forEach(function (svg) { io.observe(svg); });
    }

    /* ── ⏳ BLACK FRIDAY 2026 (temporário): contagem regressiva ──────── */
    // Atualiza todo [data-bf-unit] da página (barra do layout + AgendDemo). Ao
    // zerar, remove a barra: a página pode ter vindo do cache da Cloudflare.
    function initBlackFriday() {
        var bar = document.querySelector('[data-bf-fim]');
        if (!bar) return;
        var fim = +bar.getAttribute('data-bf-fim');
        var units = document.querySelectorAll('[data-bf-unit]');
        var timer;
        function pad(n) { return n < 10 ? '0' + n : String(n); }
        function tick() {
            var s = Math.max(0, Math.floor((fim - Date.now()) / 1000));
            var v = { d: Math.floor(s / 86400), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
            units.forEach(function (u) { u.textContent = v[u.getAttribute('data-bf-unit')]; });
            if (s === 0) {
                clearInterval(timer);
                if (bar.parentNode) bar.parentNode.removeChild(bar);
            }
        }
        tick();
        timer = setInterval(tick, 1000);
    }

    /* ── Bootstrap ────────────────────────────────────────────────── */
    ready(function () {
        initHeaderScroll();
        initMegaMenu();
        initDrawer();
        initAccordions();
        initLangSwitch();
        initTabs();
        initFaq();
        initReveal();
        initCountUp();
        initQuotes();
        initInertAnchors();
        initWordRotator();
        initContentFilter();
        initMkAnim();
        initBlackFriday();
    });
})();
